export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";